import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";

import { report_get_spare_parts } from "../../../components/Report.js";
export default class WithdrawalGoods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_detail: false,
      modal_serialno: false,
      tab: "create",

      filter_search: "",
      filter_product_id: "",
      filter_warehouse_id: "",
      filter_destination_warehouse_id: "",
      filter_category_id: "",
      filter_company_id: "",
      filter_start_date: "",
      filter_end_date: "",
      filter_activity_type: "",
      filter_status: "",
      filter_user_id: "",

      product_qrcode: "",
      product_index: -1,
      serial_list: [],

      data: [],
      count: 0,
      data_user: [],
      data_warehouse: [],
      data_company: [],
      data_product: [],
      data_category: [],
      data_repair: [],

      // stock
      document_no: "",
      repair_id: params("repair_id") || "",
      type: "",
      name: "",
      date: format_date(new Date(), "yyyy-mm-dd", "en"),
      start_date: "",
      end_date: "",
      count_item: "",
      ref_number: "",
      activity_type: "เบิกเพื่อซ่อม",
      customer_id: "",
      supplier_id: "",
      warehouse_id: "",
      destination_warehouse_id: params("warehouse_id") || "",
      user_id: "",
      amount: "",
      discount: "",
      vat: "",
      amount_net: "",
      cause: "",
      status: "",
      remark: "",
      transaction_list: [],
      is_refund: false,

      // สินค้า
      photo: "",
      product_warehouse_id: "",
      product_code: "",
      product_name: "",
      category_id: "",
      unit_name: "",
      sale_price: "",
      cost_price: "",
      product_description: "",

      is_vat: false,
      delivery_cost: "",

      detail: null,
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }

  Get = async (page) => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_destination_warehouse_id,
      filter_company_id,
      filter_status,
      filter_activity_type,
      destination_warehouse_id,
    } = this.state;
    loading(true);
    let data,
      count,
      data_user,
      data_product,
      data_warehouse,
      data_category,
      data_company,
      data_repair;
    let [
      result,
      result_user,
      result_product,
      result_warehouse,
      result_category,
      result_company,
      result_repair,
    ] = await Promise.all([
      GET("admin/stock-activities/list", {
        page: page,
        data_search: filter_search,
        start_date: filter_start_date,
        end_date: filter_end_date,
        warehouse_id: filter_warehouse_id,
        destination_warehouse_id: filter_destination_warehouse_id,
        supplier_id: filter_company_id,
        status_code: filter_status,
        activity_type: filter_activity_type,
        type: "เบิกสินค้า",
      }),
      GET("admin/setting/users/list", { page: 0, data_search: "" }),
      GET("admin/inventories/list", { page: 0, data_search: "" }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      GET("admin/setting/categories/list", { page: 0, data_search: "" }),
      GET("admin/setting/companies/list", { page: 0, data_search: "" }),
      GET("admin/repairs/list", {
        page: 0,
        status_code: "เข้าซ่อม",
      }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    if (result_user?.status) {
      data_user = result_user.data.map((e) => ({
        value: e.uid,
        label: e.full_name,
      }));
    }
    if (result_product?.status) {
      data_product = result_product.data
        .filter((e) => e.products)
        .map((e) => ({
          value: e.products?.uid,
          label: `${e.products?.product_code} ${e.products?.product_name}`,
          id: e.products?.id,
          warehouse_id: e.products?.warehouse?.uid || "",
          unit_name: e.products?.unit_name,
          is_serial_number: e.products?.is_serial_number,
          product_code: e.products?.product_code,
          product_name: e.products?.product_name,
          cost_price: e.products?.cost_price,
          category_id: e.products?.category?.uid || "",
          balance: e.balance,
          serial_number: e.serial_number,
        }));
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    if (result_category?.status) {
      data_category = result_category.data.map((e) => ({
        value: e.uid,
        label: `${e.category_code} ${e.name}`,
        id: e.id,
        warehouse_id: e.warehouse.uid,
      }));
    }
    if (result_company?.status) {
      data_company = result_company.data.map((e) => ({
        value: e.uid,
        label: e.company_name,
      }));
    }
    if (result_repair?.status) {
      data_repair = result_repair.data?.map((e) => ({
        ...e,
        value: e.uid,
        label: e.document_no,
        warehouse_id: e.warehouse?.uid,
      }));
    }
    this.setState({
      data,
      count,
      data_user,
      data_product,
      data_warehouse,
      data_category,
      data_company,
      destination_warehouse_id:
        destination_warehouse_id ||
        data_warehouse.find((e) => e.label === "แผนกซ่อม")?.value ||
        "",
      data_repair,
      warehouse_id: data_warehouse ? data_warehouse[0].value : "",
    });
    loading(false);
  };

  GetByID = async (uid) => {
    loading(true);
    let result = await GET("admin/stock-activities/list", { uid });
    this.setState({ detail: result.data, modal_detail: true });
    loading(false);
  };
  CreateUpdate = async (_status) => {
    const {
      data_product,
      id,
      uid,
      repair_id,
      data,
      document_no,
      type,
      name,
      date,
      start_date,
      end_date,
      count_item,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      destination_warehouse_id,
      user_id,
      amount,
      discount,
      vat,
      amount_net,
      cause,
      status,
      remark,
      transaction_list,
      is_vat,
      delivery_cost,
    } = this.state;
    if (!date?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกวันที่เบิก");
      return;
    } else if (!activity_type?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทการเบิก");
      return;
    } else if (!warehouse_id?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้าต้นทาง");
      return;
    } else if (!destination_warehouse_id?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้าปลายทาง");
      return;
    } else if (!user_id?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกผู้เบิก");
      return;
    }
    loading(true);
    const vatRate = is_vat ? 0.07 : 0;

    let _amount = 0;

    let serial = false;
    transaction_list.forEach((item) => {
      const qty = Number(item.qty ?? 0);
      const unitPrice = Number(item.unit_price ?? 0);
      const itemDiscount = Number(item.discount ?? 0);
      _amount += qty * (unitPrice - itemDiscount);
      item.serial_number = item.serial_number
        .toString()
        .split(",")
        .filter((e) => e);
      if (
        item.serial_number.length !== qty &&
        data_product.find((e) => e.value === item.product_id)?.is_serial_number
      ) {
        serial = true;
      }
    });

    if (serial) {
      loading(false);
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        "จำนวน Serial Number กับ จำนวนสินค้าบางรายการไม่ตรงกัน"
      );
      return;
    }
    let body = {
      type: "เบิกสินค้า",
      name,
      date,
      start_date,
      end_date,
      count_item: transaction_list.length,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      destination_warehouse_id,
      user_id,
      repair_id,
      amount: Number(_amount),
      discount: 0,
      vat: 0,
      delivery_cost: 0,
      amount_net: Number(_amount),
      cause,
      status: _status || "เสร็จสิ้น",
      remark,
      transaction_list: transaction_list.map((e) => ({ ...e })),
    };
    let result = !uid
      ? await POST("admin/stock-activities/create", body)
      : await PUT("admin/stock-activities/update/" + uid, body);
    if (result?.status) {
      alert("#", "success");
      report_get_spare_parts(uid || result.data);
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "ยกเลิก",
        "ยืนยันรายการนี้หรือไม่ ?",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);

      let body = {
        status: "ยกเลิก",
      };

      let result = await PUT("admin/stock-activities/update/" + id, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
        );
      }
      loading(false);
    }
  };

  render() {
    const {
      modal_detail,
      modal_serialno,
      tab,

      filter_search,
      filter_product_id,
      filter_warehouse_id,
      filter_destination_warehouse_id,
      filter_category_id,
      filter_start_date,
      filter_end_date,
      filter_activity_type,
      filter_status,
      filter_user_id,

      data,
      count,
      data_user,
      data_warehouse,
      data_company,
      data_product,
      data_category,
      data_repair,

      // stock
      document_no,
      repair_id,
      type,
      name,
      date,
      start_date,
      end_date,
      count_item,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      destination_warehouse_id,
      user_id,
      amount,
      discount,
      vat,
      amount_net,
      cause,
      status,
      remark,
      transaction_list,
      is_refund,

      // สินค้า
      photo,
      product_warehouse_id,
      product_code,
      product_name,
      category_id,
      unit_name,
      sale_price,
      cost_price,
      product_description,

      is_vat,
      delivery_cost,
      detail,

      product_qrcode,
      product_index,
      serial_list,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between flex-wrap mb-3">
              <h4 className="fw-bold mb-3 me-3">เบิกสินค้า</h4>
              <div className="border-1 border-secondary rounded-4 p-1 d-flex bg-light">
                <button
                  className={`btn ${
                    tab === "create" ? "btn-dark" : "btn-light"
                  } px-3`}
                  onClick={async () => {
                    this.setState({
                      tab: "create",
                      date: format_date(new Date(), "yyyy-mm-dd", "en"),
                      activity_type: "เบิกเพื่อซ่อม",
                      destination_warehouse_id:
                        data_warehouse.find((e) => e.label === "แผนกซ่อม")
                          ?.value || "",
                    });
                  }}
                >
                  สร้างรายการ
                </button>
                <div style={{ width: 4 }}></div>
                <button
                  className={`btn ${
                    tab === "history" ? "btn-dark" : "btn-light"
                  } px-3`}
                  onClick={async () => {
                    this.setState({
                      tab: "history",
                      id: "",
                      uid: "",
                      document_no: "",
                      repair_id: "",
                      type: "",
                      name: "",
                      date: "",
                      start_date: "",
                      end_date: "",
                      count_item: "",
                      ref_number: "",
                      activity_type: "",
                      customer_id: "",
                      supplier_id: "",
                      warehouse_id: "",
                      destination_warehouse_id: "",
                      user_id: "",
                      amount: "",
                      discount: "",
                      vat: "",
                      amount_net: "",
                      cause: "",
                      status: "",
                      remark: "",
                      transaction_list: [],
                    });
                  }}
                >
                  ประวัติรายการ
                </button>
              </div>
            </div>
            {tab === "create" && (
              <div>
                <div className="row mb-3">
                  {/* <div className="col-12 col-lg-7 col-xl-8 row px-0 mx-0"> */}
                  <div className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-2">
                    <div className="wpx-150 mb-1">เลขที่ใบเบิก</div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="เลขที่ใบเบิก..."
                      onChange={(e) => {
                        this.setState({ document_no: e.target.value });
                      }}
                      value={document_no}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-2">
                    <div className="wpx-150 mb-1">วันที่เบิก{required}</div>
                    <input
                      type="date"
                      className="form-control"
                      placeholder="วันที่เบิก..."
                      onChange={(e) => {
                        this.setState({ date: e.target.value });
                      }}
                      value={date}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-2">
                    <div className="wpx-150 mb-1">ประเภทการเบิก{required}</div>
                    <select
                      className="form-control"
                      onChange={(e) => {
                        this.setState({ activity_type: e.target.value });
                      }}
                      value={activity_type}
                    >
                      <option value="">ประเภทการเบิก</option>
                      <option value="เบิกเพื่อซ่อม">เบิกเพื่อซ่อม</option>
                      <option value="เบิกย้ายโกดัง">เบิกย้ายโกดัง</option>
                    </select>
                  </div>
                  <div className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-2">
                    <div className="wpx-150 mb-1">ใบแจ้งซ่อม</div>
                    <Select
                      className="form-control"
                      placeholder="เลือกใบแจ้งซ่อม..."
                      options={data_repair}
                      onChange={(e, i) => {
                        this.setState({
                          repair_id: e,
                          destination_warehouse_id: e ? i.warehouse_id : "",
                        });
                      }}
                      value={repair_id}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-2">
                    <div className="wpx-150 mb-1">
                      คลังสินค้าต้นทาง{required}
                    </div>
                    <Select
                      className="form-control"
                      placeholder="คลังสินค้าต้นทาง..."
                      options={data_warehouse}
                      onChange={(e) => {
                        this.setState({ warehouse_id: e });
                      }}
                      value={warehouse_id}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-2">
                    <div className="wpx-150 mb-1">
                      คลังสินค้าปลายทาง{required}
                    </div>
                    <Select
                      className="form-control"
                      placeholder="คลังสินค้าปลายทาง..."
                      options={data_warehouse}
                      onChange={(e) => {
                        this.setState({ destination_warehouse_id: e });
                      }}
                      value={destination_warehouse_id}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-2">
                    <div className="wpx-150 mb-1">ผู้เบิก{required}</div>
                    <Select
                      className="form-control"
                      placeholder="เลือกผู้เบิก..."
                      options={data_user}
                      onChange={(e) => {
                        this.setState({ user_id: e });
                      }}
                      value={user_id}
                    />
                  </div>
                  {/* </div> */}
                  {/* <div className="col-12 col-lg-5 col-xl-4">
                    <div className="wpx-150 mb-1">หมายเหตุ{required}</div>
                    <textarea
                      rows={5}
                      type="text"
                      className="form-control"
                      placeholder="หมายเหตุ..."
                      onChange={(e) => {
                        this.setState({ return_code: e.target.value });
                      }}
                      value={return_code}
                    />
                  </div> */}
                </div>
                <hr />
                <div>
                  <div className="d-flex flex-wrap">
                    {/* <Select
                      type="text"
                      className="form-control wpx-200 me-2 mb-2"
                      placeholder="ค้นหาสินค้า..."
                      options={data_product}
                      onChange={(e) => {
                        this.setState({ filter_product_id: e.target.value });
                      }}
                      value={filter_product_id}
                    />
                    <div className="wpx-200 me-2 mb-2">
                      <Select
                        className="form-control"
                        placeholder="คลังสินค้า..."
                        options={data_warehouse}
                        onChange={(e) => {
                          this.setState({ filter_warehouse_id: e });
                        }}
                        value={filter_warehouse_id}
                      />
                    </div>
                    <div className="wpx-200 me-2 mb-2">
                      <Select
                        className="form-control"
                        placeholder="หมวดหมู่..."
                        options={data_category}
                        onChange={(e) => {
                          this.setState({ filter_category_id: e });
                        }}
                        value={filter_category_id}
                      />
                    </div> */}

                    <input
                      type="text"
                      className="form-control wpx-250 me-2 mb-2"
                      placeholder="สแกนบาร์โค้ดเพื่อเพิ่มสินค้า..."
                      onChange={(e) => {
                        this.setState({
                          product_qrcode: e.target.value,
                        });
                      }}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") {
                          const product_code =
                            product_qrcode.split("|")[0] || "";
                          const product_serial =
                            product_qrcode.split("|")[1] || "";
                          let _transaction_list = transaction_list;
                          let index = _transaction_list.findIndex(
                            (t) => t.product_code === product_code
                          );
                          if (index !== -1) {
                            _transaction_list[index].qty += 1;
                            const is_serial_number = data_product.find(
                              (e) =>
                                e.warehouse_id === warehouse_id &&
                                e.product_code === product_code
                            )?.is_serial_number;
                            if (is_serial_number) {
                              _transaction_list[index].serial_number =
                                _transaction_list[index].serial_number
                                  ? _transaction_list[index].serial_number +
                                    "," +
                                    product_serial
                                  : product_serial;
                            }
                          } else {
                            const product = data_product.filter(
                              (e) => e.warehouse_id === warehouse_id
                            );
                            const select_product = product.find(
                              (p) => p.product_code === product_code
                            );
                            if (select_product) {
                              _transaction_list = [
                                ...transaction_list,
                                {
                                  uid: "",
                                  type: "",
                                  product_id: select_product.value,
                                  product_name: select_product.product_name,
                                  product_code: select_product.product_code,
                                  product_type: select_product.product_type,
                                  serial_number: select_product.is_serial_number
                                    ? product_serial
                                    : "",
                                  warehouse_id: warehouse_id,
                                  balance: select_product.balance,
                                  warehouse_name: "",
                                  category_id: select_product.category_id,
                                  category_name: "",
                                  qty: 1,
                                  unit_name: "",
                                  cause: "",
                                  discount: "",
                                  sale_price: "",
                                  cost_price: "",
                                  unit_price: "",
                                  amount: "",
                                  remark: "",
                                },
                              ];
                            } else {
                              alert(
                                "",
                                "info",
                                "แจ้งเตือน",
                                "ไม่มีรหัสสินค้านี้ในระบบ"
                              );
                              return;
                            }
                          }
                          this.setState({
                            product_qrcode: "",
                            product_serial: "",
                            transaction_list: _transaction_list,
                          });
                        }
                      }}
                      value={product_qrcode}
                    />
                    <div className="d-flex">
                      <button
                        className="btn btn-dark px-3 me-2 mb-2"
                        onClick={() => {
                          this.setState(
                            {
                              transaction_list: [
                                ...this.state.transaction_list,
                                {
                                  uid: "",
                                  type: "",
                                  product_id: "",
                                  product_name: "",
                                  product_code: "",
                                  product_type: "",
                                  serial_number: "",
                                  warehouse_id: "",
                                  warehouse_name: "",
                                  category_id: "",
                                  category_name: "",
                                  qty: 1,
                                  unit_name: "",
                                  cause: "",
                                  discount: "",
                                  sale_price: "",
                                  cost_price: "",
                                  unit_price: "",
                                  amount: "",
                                },
                              ],
                            },
                            () => {
                              try {
                                const index =
                                  this.state.transaction_list.length - 1;
                                document
                                  .getElementById("price-" + index)
                                  ?.focus();
                              } catch (e) {
                                console.error(
                                  "Error focusing on product input:",
                                  e
                                );
                              }
                            }
                          );
                        }}
                      >
                        เพิ่มรายการ
                      </button>
                    </div>
                  </div>
                  <div>
                    <table className="table rounded-3 table-hover">
                      <thead>
                        <tr>
                          <td className="text-nowrap">ลำดับ</td>
                          <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                          <td className="text-nowrap">หมวดหมู่</td>
                          <td className="text-nowrap">Serial No.</td>
                          <td className="text-nowrap text-center">คงเหลือ</td>
                          <td className="text-nowrap text-center">จำนวนเบิก</td>
                          <td className="text-nowrap text-end">ราคาต้นทุน</td>
                          <td className="text-nowrap text-end">ราคารวม</td>
                          <td></td>
                        </tr>
                      </thead>
                      <tbody>
                        {transaction_list?.map((item, index) => (
                          <tr>
                            <td className="text-nowrap">{index + 1}</td>
                            <td className="text-nowrap">
                              <Select
                                className="form-control"
                                placeholder="ค้นหาสินค้า..."
                                options={data_product.filter(
                                  (e) =>
                                    warehouse_id &&
                                    e.warehouse_id === warehouse_id
                                )}
                                onChange={(e, i) => {
                                  transaction_list[index].product_id = e;
                                  transaction_list[index].product_code =
                                    i.product_code;
                                  transaction_list[index].product_name =
                                    i.product_name;
                                  transaction_list[index].unit_name =
                                    i.unit_name;
                                  transaction_list[index].cost_price =
                                    i.cost_price;
                                  transaction_list[index].unit_price =
                                    i.cost_price;
                                  transaction_list[index].category_id =
                                    i.category_id;
                                  this.setState({ transaction_list });
                                }}
                                value={item.product_id}
                              />
                            </td>
                            <td className="text-nowrap">
                              <Select
                                className="form-control"
                                placeholder="หมวดหมู่..."
                                options={data_category.filter(
                                  (e) => e.warehouse_id === warehouse_id
                                )}
                                onChange={(e) => {
                                  transaction_list[index].category_id = e;
                                  this.setState({ transaction_list });
                                }}
                                value={item.category_id}
                              />
                            </td>
                            <td className="text-nowrap">
                              {data_product.find(
                                (e) => e.value === item.product_id
                              )?.is_serial_number && (
                                <div className="d-flex align-items-center">
                                  <input
                                    type="text"
                                    className="form-control mx-1"
                                    onChange={(e) => {
                                      transaction_list[index].serial_number =
                                        e.target.value;
                                      this.setState({ transaction_list });
                                    }}
                                    value={item.serial_number}
                                  />
                                  <BtnIcon
                                    type="update"
                                    title="เลือก Serial No."
                                    onClick={() => {
                                      this.setState({
                                        modal_serialno: true,
                                        product_index: index,
                                        serial_list:
                                          data_product
                                            .find(
                                              (e) =>
                                                e.product_code ===
                                                  item.product_code &&
                                                e.warehouse_id === warehouse_id
                                            )
                                            ?.serial_number.map((e) => ({
                                              serial_number: e,
                                              selected:
                                                item.serial_number.includes(e),
                                            })) || [],
                                      });
                                    }}
                                  />
                                </div>
                              )}
                            </td>
                            <td className="text-nowrap text-center">
                              {data_product?.find(
                                (e) => e.value === item.product_id
                              )?.balance || 0}
                            </td>
                            <td className="text-nowrap">
                              <div className="d-flex justify-content-center">
                                <button
                                  className="btn btn-primary wpx-30"
                                  onClick={async () => {
                                    if (item.qty <= 1) {
                                      if (
                                        await alert(
                                          "",
                                          "info",
                                          "ยืนยัน",
                                          "ยืนยันการลบข้อมูลนี้หรือไม่",
                                          "ลบข้อมูล",
                                          "ยกเลิก"
                                        )
                                      ) {
                                        this.setState({
                                          transaction_list:
                                            transaction_list.filter(
                                              (_, i) => i !== index
                                            ),
                                        });
                                      }
                                    } else {
                                      transaction_list[index].qty = Math.max(
                                        0,
                                        item.qty - 1
                                      );
                                      this.setState({ transaction_list });
                                    }
                                  }}
                                >
                                  -
                                </button>
                                <input
                                  type="text"
                                  className="form-control wpx-60 mx-1 text-center"
                                  onChange={(e) => {
                                    if (!float(e.target.value)) return;
                                    transaction_list[index].qty = Number(
                                      e.target.value
                                    );
                                    this.setState({ transaction_list });
                                  }}
                                  value={item.qty}
                                />
                                <button
                                  className="btn btn-primary wpx-30"
                                  onClick={() => {
                                    transaction_list[index].qty = Math.max(
                                      0,
                                      item.qty + 1
                                    );
                                    this.setState({ transaction_list });
                                  }}
                                >
                                  +
                                </button>
                              </div>
                            </td>

                            <td className="text-nowrap">
                              <input
                                type="text"
                                className="form-control mx-1 text-end"
                                onChange={(e) => {
                                  if (!float(e.target.value)) return;
                                  transaction_list[index].unit_price =
                                    e.target.value;
                                  transaction_list[index].cost_price =
                                    e.target.value;
                                  this.setState({ transaction_list });
                                }}
                                onKeyUp={(e) => {
                                  if (e.key === "Enter") {
                                    if (index === transaction_list.length - 1) {
                                      this.setState(
                                        {
                                          transaction_list: [
                                            ...transaction_list,
                                            {
                                              uid: "",
                                              type: "",
                                              product_id: "",
                                              product_name: "",
                                              product_code: "",
                                              product_type: "",
                                              serial_number: "",
                                              warehouse_id: "",
                                              warehouse_name: "",
                                              category_id: "",
                                              category_name: "",
                                              qty: 1,
                                              unit_name: "",
                                              cause: "",
                                              discount: "",
                                              sale_price: "",
                                              cost_price: "",
                                              unit_price: "",
                                              amount: "",
                                            },
                                          ],
                                        },

                                        () => {
                                          try {
                                            const index =
                                              this.state.transaction_list
                                                .length - 1;
                                            document
                                              .getElementById("price-" + index)
                                              ?.focus();
                                          } catch (e) {
                                            console.error(
                                              "Error focusing on product input:",
                                              e
                                            );
                                          }
                                        }
                                      );
                                    } else {
                                      try {
                                        document
                                          .getElementById(
                                            "price-" + (index + 1)
                                          )
                                          .focus();
                                      } catch (e) {
                                        console.error(
                                          "Error focusing on product input:",
                                          e
                                        );
                                      }
                                    }
                                  }
                                }}
                                value={item.unit_price}
                                id={`price-${index}`}
                              />
                            </td>

                            <td className="text-nowrap text-end">
                              {toFixed(
                                Number(item.qty) * Number(item.unit_price)
                              ) || "0.00"}
                            </td>
                            <td className="text-center align-middle wpx-100">
                              <div className="d-flex">
                                <BtnIcon
                                  className="receive-goods.delete"
                                  type="delete"
                                  onClick={async () => {
                                    if (
                                      await alert(
                                        "",
                                        "info",
                                        "ยืนยัน",
                                        "ยืนยันการลบข้อมูลนี้หรือไม่",
                                        "ลบข้อมูล",
                                        "ยกเลิก"
                                      )
                                    ) {
                                      this.setState({
                                        transaction_list:
                                          transaction_list.filter(
                                            (_, i) => i !== index
                                          ),
                                      });
                                    }
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan={5}>รวมทั้งสิ้น</td>
                          <td className="text-center">
                            {total(transaction_list, "qty")}
                          </td>
                          <td></td>
                          <td className="text-end">
                            <h4 className="fw-bold">
                              {(() => {
                                let total = 0;
                                transaction_list.forEach((item) => {
                                  total +=
                                    Number(item.qty) * Number(item.unit_price);
                                });
                                if (isNaN(total)) total = 0;
                                return toFixed(total || 0);
                              })()}
                            </h4>
                          </td>

                          <td></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <div className="pt-0 border-0">
                  <div className="w-100 mb-3">
                    <div className="wpx-150 mb-1">หมายเหตุ</div>
                    <textarea
                      rows={5}
                      type="text"
                      className="form-control"
                      placeholder="หมายเหตุ..."
                      onChange={(e) => {
                        this.setState({ remark: e.target.value });
                      }}
                      value={remark}
                    />
                  </div>
                  <div className="d-flex justify-content-end align-items-end ps-3">
                    <button
                      className="btn btn-primary px-5 me-1 text-nowrap"
                      onClick={() => {
                        this.CreateUpdate("เสร็จสิ้น");
                      }}
                    >
                      บันทึกการเบิก
                    </button>
                  </div>
                </div>
              </div>
            )}
            {tab === "history" && (
              <div>
                <div className="d-flex align-items-center flex-wrap">
                  <input
                    type="text"
                    className="form-control wpx-200 me-2 mb-2"
                    placeholder="ค้นหา ใบเบิกสินค้า ,ใบแจ้งซ่อม..."
                    onChange={(e) => {
                      this.setState({ filter_search: e.target.value });
                    }}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        this.Get(1);
                      }
                    }}
                    value={filter_search}
                  />
                  <input
                    type="date"
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_start_date: e.target.value });
                    }}
                    value={filter_start_date}
                  />
                  <span className="px-2 me-2 mb-2">ถึง</span>
                  <input
                    type="date"
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_end_date: e.target.value });
                    }}
                    value={filter_end_date}
                  />
                  <select
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_activity_type: e.target.value });
                    }}
                    value={filter_activity_type}
                  >
                    <option value="">ประเภทการเบิก</option>
                    <option value="เบิกเพื่อซ่อม">เบิกเพื่อซ่อม</option>
                    <option value="เบิกย้ายโกดัง">เบิกย้ายโกดัง</option>
                  </select>
                  <select
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_status: e.target.value });
                    }}
                    value={filter_status}
                  >
                    <option value="">สถานะ</option>
                    <option value="เสร็จสิ้น">เสร็จสิ้น</option>
                    <option value="ยกเลิก">ยกเลิก</option>
                  </select>
                  <div className="wpx-200 me-2 mb-2">
                    <Select
                      className="form-control"
                      placeholder="เลือกใบแจ้งซ่อม..."
                      options={data_user}
                      onChange={(e) => {
                        this.setState({ filter_user_id: e });
                      }}
                      value={filter_user_id}
                      disabled
                    />
                  </div>
                  <div className="wpx-200 me-2 mb-2">
                    <Select
                      className="form-control"
                      placeholder="คลังสินค้าต้นทาง..."
                      options={data_warehouse}
                      onChange={(e) => {
                        this.setState({ filter_warehouse_id: e });
                      }}
                      value={filter_warehouse_id}
                    />
                  </div>
                  <div className="wpx-200 me-2 mb-2">
                    <Select
                      className="form-control"
                      placeholder="คลังสินค้าปลายทาง..."
                      options={data_warehouse}
                      onChange={(e) => {
                        this.setState({ filter_destination_warehouse_id: e });
                      }}
                      value={filter_destination_warehouse_id}
                    />
                  </div>
                  <div className="d-flex">
                    <button
                      className="btn btn-dark px-3 me-2 mb-2"
                      onClick={() => {
                        this.Get(1);
                      }}
                    >
                      ค้นหา
                    </button>
                    <button
                      className="btn btn-outline-dark px-3 me-2 mb-2"
                      onClick={() => {
                        this.setState({
                          filter_search: "",
                          filter_receive_date: "",
                          filter_warehouse_id: "",
                          filter_company_id: "",
                          filter_category_id: "",
                          filter_status: "",
                          filter_start_date: "",
                          filter_end_date: "",
                          filter_activity_type: "",
                        });
                        setTimeout(() => {
                          this.Get(1);
                        }, 100);
                      }}
                    >
                      ล้างค่า
                    </button>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table rounded-3 overflow-hidden table-hover">
                    <thead>
                      <tr>
                        <td className="text-nowrap">เลขที่ใบเบิก</td>
                        <td className="text-nowrap">วันที่เบิก</td>
                        <td className="text-nowrap">ประเภทการเบิก</td>
                        <td className="text-nowrap">ใบแจ้งซ่อม</td>
                        <td className="text-nowrap">คลังสินค้าต้นทาง</td>
                        <td className="text-nowrap">คลังสินค้าปลายทาง</td>
                        <td className="text-nowrap">ผู้เบิก</td>
                        <td className="text-nowrap">สถานะ</td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((item, index) => (
                        <tr>
                          <td className="text-nowrap">
                            {item.document_no || "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.created_at
                              ? format_date(item.created_at)
                              : "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.activity_type || "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.repair?.document_no || "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.warehouse?.name || "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.destination_warehouse?.name || "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.user?.full_name || "-"}
                          </td>
                          <td className="text-nowrap">{item.status || "-"}</td>
                          <td className="text-center align-middle wpx-100">
                            <div className="d-flex">
                              <BtnIcon
                                type="view"
                                onClick={async () => {
                                  await this.GetByID(item.uid);
                                }}
                              />
                              {item.status === "เสร็จสิ้น" && (
                                <BtnIcon
                                  className="withdrawal-goods.delete"
                                  type="delete"
                                  onClick={() => {
                                    this.Delete(item.uid);
                                  }}
                                />
                              )}
                              <BtnIcon
                                type="print"
                                onClick={() => {
                                  report_get_spare_parts(item.uid);
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
                  <Pagination
                    className="mb-3"
                    count={Math.ceil(count / 10) || 1}
                    showFirstButton
                    showLastButton
                    onChange={(_, page) => this.Get(page)}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* VIEW */}
        <Modal
          show={this.state.modal_detail}
          onHide={() => this.setState({ modal_detail: false })}
          fullscreen={true}
        >
          <Modal.Header closeButton>
            <h4 className="mb-0">รายละเอียด</h4>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">สถานะ</label>
              <label>
                {detail?.status === "เสร็จสิ้น"
                  ? Status("เสร็จสิ้น", "success")
                  : Status("ยกเลิก", "danger")}
              </label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">เลขที่เอกสาร</label>
              <label>{detail?.document_no || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">วันที่เบิก</label>
              <label>{detail?.date ? format_date(detail?.date) : ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">ประเภทการเบิก</label>
              <label>{detail?.activity_type || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">คลังสินค้าต้นทาง</label>
              <label>{detail?.warehouse?.name || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">ผู้ดำเนินการ</label>
              <label>{detail?.user?.full_name || ""}</label>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">ลำดับ</td>
                    <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                    <td className="text-nowrap">Serial No.</td>
                    <td className="text-nowrap text-center">จำนวน</td>
                    <td className="text-nowrap text-center">ราคา/หน่วย</td>
                    <td className="text-nowrap text-center">ส่วนลด</td>
                    <td className="text-nowrap text-end">ราคาหลังหักส่วนลด</td>
                    <td className="text-nowrap text-end">มูลค่ารวม</td>
                  </tr>
                </thead>
                <tbody>
                  {detail?.transaction_list?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{index + 1}</td>
                      <td className="text-nowrap">
                        {item.product_code} {item.product_name}
                      </td>
                      <td className="text-nowrap">
                        {item.serial_number?.join(", ") || ""}
                      </td>
                      <td className="text-nowrap">{item.qty}</td>
                      <td className="text-nowrap">{item.unit_price}</td>
                      <td className="text-nowrap">{item.discount}</td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          Number(item.unit_price) - Number(item.discount)
                        )}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          Number(item.qty) *
                            (Number(item.unit_price) - Number(item.discount))
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="d-flex justify-content-between">
              <div>
                <div className="d-flex mb-2 flex-wrap">
                  <label className="wpx-150">หมายเหตุ</label>
                  <label>{detail?.remark || ""}</label>
                </div>
              </div>
              <div>
                <div className="d-flex mb-2 flex-wrap">
                  <label className="wpx-150">รวมเป็นเงิน</label>
                  <label className="wpx-100 text-end px-3">
                    {toFixed(detail?.amount)}
                  </label>
                  <label>บาท</label>
                </div>
                <div className="d-flex mb-2 flex-wrap">
                  <label className="wpx-150">ส่วนลด</label>
                  <label className="wpx-100 text-end px-3">
                    {toFixed(detail?.discount)}
                  </label>
                  <label>บาท</label>
                </div>
                <div className="d-flex mb-2 flex-wrap">
                  <label className="wpx-150">ราคาหลังหักส่วนลด</label>
                  <label className="wpx-100 text-end px-3">
                    {toFixed(detail?.amount - detail?.discount)}
                  </label>
                  <label>บาท</label>
                </div>
                <div className="d-flex mb-2 flex-wrap">
                  <label className="wpx-150">ภาษีมูลค่าเพิ่ม 7%</label>
                  <label className="wpx-100 text-end px-3">
                    {toFixed(detail?.vat)}
                  </label>
                  <label>บาท</label>
                </div>
                <div className="d-flex mb-2 flex-wrap">
                  <label className="wpx-150">ค่าส่ง</label>
                  <label className="wpx-100 text-end px-3">
                    {toFixed(detail?.delivery_cost)}
                  </label>
                  <label>บาท</label>
                </div>
                <div className="d-flex mb-2 flex-wrap">
                  <label className="wpx-150">จำนวนเงินรวมทั้งหมด</label>
                  <label className="wpx-100 text-end px-3">
                    {toFixed(detail?.amount_net)}
                  </label>
                  <label>บาท</label>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={modal_serialno}
          onHide={() => this.setState({ modal_serialno: false })}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">เลือก Serial No.</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="table-responsive mb-3">
              <table className="table table-hover table-striped-columns">
                <thead>
                  <tr>
                    <td className="text-nowrap wpx-50 text-center">
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          const checked = e.target.checked;
                          this.setState({
                            serial_list: serial_list?.map((item) => ({
                              ...item,
                              selected: checked,
                            })),
                          });
                        }}
                        checked={serial_list?.every((item) => item.selected)}
                      />
                    </td>
                    <td className="text-nowrap">Serial No.</td>
                  </tr>
                </thead>
                <tbody>
                  {serial_list?.map((item, index) => (
                    <tr style={{ cursor: "pointer" }}>
                      <td className="text-center">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            let _data = [...serial_list];
                            _data[index].selected = e.target.checked;
                            this.setState({ serial_list: _data });
                          }}
                          checked={item.selected}
                        />
                      </td>
                      <td>{item.serial_number}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  let _data = transaction_list;
                  _data[product_index].serial_number = serial_list
                    .filter((e) => e.selected)
                    .map((e) => e.serial_number)
                    .toString();
                  this.setState({
                    transaction_list: _data,
                    modal_serialno: false,
                    product_index: -1,
                  });
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_serialno: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
